import EditName from './edit_amount'
import { reduxForm } from 'redux-form'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector, isGNSelector } from 'redux/selectors/campaign'
import { combine, required, atMost, atLeast } from 'lib/validators'
import { getI18n } from 'client/i18n'
import { formatMoney } from 'client/griffin'
import { CROWDFUNDING_GOAL_AMOUNT } from 'shared/shared_consts'

const i18n = getI18n('components/edit_glimpse/edit_amount')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  const campaignType = campaign.campaign_type
  let MIN_AMOUNT
  let MAX_AMOUNT
  let formattedMaxGoalAmount
  let formattedMinGoalAmount = formatMoney(
    campaign.currency,
    state.flags.min_amount_donation
  )
  let validators = [required('goal', i18n('goal_amount_required'))]

  if (isGNSelector(state, props)) {
    MIN_AMOUNT = CROWDFUNDING_GOAL_AMOUNT[campaign.country_code].MIN_AMOUNT
    MAX_AMOUNT = CROWDFUNDING_GOAL_AMOUNT[campaign.country_code].MAX_AMOUNT
    formattedMaxGoalAmount = formatMoney(campaign.currency, MAX_AMOUNT)
    formattedMinGoalAmount = formatMoney(campaign.currency, MIN_AMOUNT)

    validators.push(
      atMost(
        'goal',
        MAX_AMOUNT,
        i18n('goal_amount_invalid', {
          amount: formattedMaxGoalAmount,
        })
      )
    )
  }

  validators.push(
    atLeast(
      'goal',
      MIN_AMOUNT || state.flags.min_amount_donation,
      i18n('goal_amount_invalid_min', {
        amount: formattedMinGoalAmount,
      })
    )
  )

  return {
    validate: combine(...validators),
    initialValues: {
      goal: campaign.goal,
    },
    currencyCode: campaign.currency,
    campaignType,
    formattedMaxGoalAmount,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(
        updateRemotely(campaignId, { goal: formValues.goal || 0 })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'edit_amount',
    fields: ['goal'],
  },
  mapStateToProps,
  mapDispatchToProps
)(EditName)
